import React, { lazy, Suspense, useEffect, useState } from 'react';
//import { Route, Routes, useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useNavigate, useLocation, RouteObject, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ToastContainer, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import GlobalStyles from './styles/Global.styled';
import { useAppSelector } from '../../hooks/customHooks';
//import { darkTheme, regularTheme } from './styles/Themes';
import { regularTheme } from './styles/Themes';
//import { clearLocationFiltersFromGridDataState, Theme } from '../../features/preferencesSlice';
import { clearLocationFiltersFromGridDataState } from '../../features/preferencesSlice';
import './styles/ToastTheme.css';
import { StudioMenu } from '@csg-cdd-common/studio-menu';
import {
  MessageCenterRoute,
  MessageDetailsRoute,
  TrashBinRoute,
  ReportingRoute,
  ForgotPasswordConfirmationRoute,
  ForgotPasswordRoute,
  LoginRoute,
  HelpDeskRoute,
  LoadingRoute,
  isAuthRoute,
  HeartbeatRoute,
  UserAccountRoute,
  LandingRoute,
  TemplateMaintenanceRoute,
} from '@/common/routes';
import { useAppDispatch } from '@/hooks/customHooks';
import { signOut, setNative, whoAmI } from '@/features/authSlice';
import { SLoaderCenter } from '@/presentation/loader/Loader.styled';
import NetworkError from '@/pages/error/NetworkError';
import { bcToastContainerId, toastsToDismissOnNavigation } from '../shared/Toasts';
import Api from '@/api/helpers';
import { SaveUserPreferencesRequest } from '@/api/client';
import { store } from '@/common/store';
import TimeoutModal from './TimeoutModal';
import SelectivityTemplateMaintenance from '../selectivity-template-maintenance/SelectivityTemplateMaintenance';
import CustomError from '@/pages/error/CustomError';
import { Provider } from 'react-redux';
import Placebo from './Placebo';
import ContactUs from '../help-desk/ContactUs';
import ForgotPassword from '../auth/forgot-password/ForgotPassword';
import ForgotPasswordConfirmation from '../auth/forgot-password-confirmation/ForgotPasswordConfirmation';
import Heartbeat from '@/pages/Heartbeat';
const TrashBin = lazy(() => import('../trash-bin/TrashBin'));
const Reporting = lazy(() => import('../reporting/Reporting'));
const MessageCenter = lazy(() => import('../message-center/MessageCenter'));
const MessageDetails = lazy(() => import('../message-details/MessageDetails'));
const NotFound = lazy(() => import('../../pages/error/NotFound'));
//const ForgotPassword = lazy(() => import('../auth/forgot-password/ForgotPassword'));
// const ForgotPasswordConfirmation = lazy(
//   () => import('../auth/forgot-password-confirmation/ForgotPasswordConfirmation'),
// );
//const ContactUs = lazy(() => import('../help-desk/ContactUs'));
// const Heartbeat = lazy(() => import('../../pages/Heartbeat'));
const UserAccount = lazy(() => import('../user-account/UserAccount'));
const Landing = lazy(() => import('../landing/Landing'));
const Login = lazy(() => import('../auth/login/Login'));

const basePath = (window as any).CSG_CONFIG.BASE_PATH;

let warningTimeout: ReturnType<typeof setTimeout> = setTimeout(setInitialTimout, 1);
let finalTimeout: ReturnType<typeof setTimeout> = setTimeout(setInitialTimout, 1);
function setInitialTimout() {
  return;
}

function App() {
  //const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isNative, setIsNative] = useState<boolean | undefined>(true);
  const [isSignedIn, setIsSignedIn] = useState<boolean>(false);

  useEffect(() => {
    const fetchIsNativeBc = async () => {
      try {
        const response = await fetch(`${(window as any).CSG_CONFIG.BASE_URL}/auth/isNativeBc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const json = await response.json();
        setIsNative(json);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };
    fetchIsNativeBc();
  }, []);

  const renderConditionalRoutes = (): RouteObject[] => {
    const notSignedInRoutes: RouteObject[] = [
      {
        path: '',
        element: <Login />,
      },
    ];

    const signedInRoutes: RouteObject[] = [
      {
        path: '',
        element: <Landing />,
      },
      {
        path: 'bc/message-center',
        element: <MessageCenter />,
      },
      // https://billcomposer-blue-qa.csgsupport.com/message-details/234182/0000-0001/charterutopia
      {
        path: `message-details/:messageId/:sysPrin/:docTypeId`,
        element: <MessageDetails />,
      },
      {
        path: 'message-details',
        element: <MessageDetails />,
      },
      //<Route path={`${MessageDetailsRoute}/:messageId/:sysPrin/:docTypeId`} element={<MessageDetails />} />
      {
        path: 'selectivity-template-maintenance',
        element: <SelectivityTemplateMaintenance />,
      },
      //<Route path={TemplateMaintenanceRoute} element={<SelectivityTemplateMaintenance />} />
      {
        path: 'trash-bin',
        element: <TrashBin />,
      },
      {
        path: 'user-account',
        element: <UserAccount />,
      },
      {
        path: 'reporting',
        element: <Reporting />,
      },
    ];

    const auxRoutes: RouteObject[] = [
      {
        path: '/bc',
        element: <UserApp isNativeBC={isNative} setIsSignedIn={setIsSignedIn} />,
        children: [
          ...(!isNative && isSignedIn ? signedInRoutes : isSignedIn ? signedInRoutes : notSignedInRoutes),
          { path: '*' },
        ],
      },
    ];
    return auxRoutes;
  };
  // const renderRoutes = (): RouteObject[] => {
  //   const primaryRoutes = renderConditionalRoutes(); // return RouteObject[]
  //   const auxRoutes: RouteObject[] = [
  //     {
  //       path: LoadingRoute,
  //       element: <SLoaderCenter sizePx={50} borderPx={4} />,
  //     },
  //   ];
  //   const allRoutes = primaryRoutes.concat(auxRoutes);
  //   return allRoutes;
  // };

  const getStudio = () => {
    return (
      <StudioMenu // <-- from NPM module
        showRouteOnError={true}
        localRoutes={[
          {
            // <-- local routes for this app
            path: (window as any).CSG_CONFIG.BASE_PATH,
            //path: 'bc',
            element: (
              <>
                <Provider store={store}>
                  <UserApp isNativeBC={isNative} setIsSignedIn={setIsSignedIn} />
                </Provider>
              </>
            ),
            children: renderConditionalRoutes(),
            // children: [
            //   {
            //     path: '*', // <-- catch all route
            //     element: <NotFound />,
            //     // path: LoginRoute,
            //     // element: <Login />,
            //   },
            // ],
          },
        ]}
      />
    );
  };

  const getBC = () => {
    return (
      <div>
        <Provider store={store}>
          <Placebo localRoutes={renderConditionalRoutes()}>
            <UserApp isNativeBC={isNative} setIsSignedIn={setIsSignedIn} />
          </Placebo>
        </Provider>
      </div>
    );
  };
  return <div className="App">{isNative === undefined ? getBC() : isNative ? getBC() : getStudio()}</div>;
}

interface IUserApp {
  isNativeBC: boolean | undefined;
  setIsSignedIn: (value: boolean) => void;
}
const UserApp: React.FC<IUserApp> = ({ isNativeBC, setIsSignedIn }) => {
  const dispatch = useAppDispatch();
  /* const theme = useAppSelector((state) => state.preferences.theme); */
  const { isLoginRedirect } = useAppSelector((state) => state.auth);
  //const { isNative } = useAppSelector((state) => state.auth);
  const { isSignedIn, isPassResetRequired, isFetchingWhoAmI, isLoggingOut } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const isNetworkError = useAppSelector((state) => state.auth.isNetworkError);
  const fullScreenErrorMsg = useAppSelector((state) => state.auth.fullscreenErrorMsg);
  const location = useLocation();
  const activeDocType = useAppSelector((state) => state.docTypes.activeDocType);
  const gridDocTypePk = useAppSelector((state) => state.preferences.docTypePk);
  const timeToAuthExpiry = useAppSelector((state) => state.auth.timeToAuthExpiry);
  const [showTimeoutModal, setShowTimeoutModal] = useState<boolean>(false);
  let warningLeadTimeMillis: number = timeToAuthExpiry * 1000 - (window as any).CSG_CONFIG.WARNING_LEADTIME_MILLIS;
  const warningLeadTimeBackoff: number =
    timeToAuthExpiry * 1000 - warningLeadTimeMillis - (window as any).CSG_CONFIG.WARNING_LEADTIME_BACKOFF;
  // const auxRoutes: RouteObject[] = [
  //   {
  //     path: '/bc',
  //     element: <UserApp setIsNative={setIsNative} />,
  //     children: [
  //       {
  //         path: '',
  //         element: <Login />,
  //       },
  //       // {
  //       //   path: '',
  //       //   element: <Landing />,
  //       // },
  //       {
  //         path: 'message-center',
  //         element: <MessageCenter />,
  //       },
  //       // https://billcomposer-blue-qa.csgsupport.com/message-details/234182/0000-0001/charterutopia
  //       {
  //         path: `message-details/:messageId/:sysPrin/:docTypeId`,
  //         element: <MessageDetails />,
  //       },
  //       {
  //         path: 'message-details',
  //         element: <MessageDetails />,
  //       },
  //       //<Route path={`${MessageDetailsRoute}/:messageId/:sysPrin/:docTypeId`} element={<MessageDetails />} />
  //       {
  //         path: 'selectivity-template-maintenance',
  //         element: <SelectivityTemplateMaintenance />,
  //       },
  //       //<Route path={TemplateMaintenanceRoute} element={<SelectivityTemplateMaintenance />} />
  //       {
  //         path: 'trash-bin',
  //         element: <TrashBin />,
  //       },
  //       {
  //         path: 'user-account',
  //         element: <UserAccount />,
  //       },
  //       {
  //         path: 'reporting',
  //         element: <Reporting />,
  //       },
  //     ],
  //   },
  // ];
  /* const router = useMemo(() => createBrowserRouter(auxRoutes), []); */

  useEffect(() => {
    dispatch(whoAmI());
    const updateUserPreferences = () => {
      const client = Api.getUserClient(dispatch);
      const preferencesJson = JSON.stringify(store.getState().preferences);
      localStorage.setItem('preferences', preferencesJson);
      client.saveUserPreferences(new SaveUserPreferencesRequest({ preferencesJson: preferencesJson }));
    };
    window.addEventListener('beforeunload', updateUserPreferences);
    return () => {
      window.removeEventListener('beforeunload', updateUserPreferences);
      updateUserPreferences();
    };
  }, []);

  useEffect(() => {
    if (!isNativeBC) {
      const keepSessionAlive = () => {
        Api.getAuthClient(dispatch).refreshAuthToken();
      };
      const intervalId = setInterval(keepSessionAlive, 60000);

      return () => clearInterval(intervalId);
    }
  });

  useEffect(() => {
    if (!isFetchingWhoAmI) {
      //setIsNative(isNative);
      setIsSignedIn(isSignedIn);
    }
  }, [isFetchingWhoAmI]);

  useEffect(() => {
    if (location.pathname) {
      toastsToDismissOnNavigation.forEach((id) => toast.dismiss(id));
      toastsToDismissOnNavigation.length = 0;
    }
    if (!isFetchingWhoAmI && !isSignedIn && isAuthRoute(location.pathname)) {
      navigate(`/${basePath}/${LoginRoute}`);
      //navigate('');
    }
  }, [isFetchingWhoAmI, isSignedIn, location.pathname]);

  // Redirect to Message Center or Landing only after login or page load, not when user toggles preference.
  useEffect(() => {
    dispatch(setNative(isNativeBC));
    if (!isFetchingWhoAmI && isSignedIn && !isPassResetRequired) {
      if (isLoginRedirect) {
        navigate(`/${basePath}/${MessageCenterRoute}`);
      } else {
        navigate(`/${basePath}/${LandingRoute}`);
      }
    }
  }, [isSignedIn]);

  useEffect(() => {
    if (activeDocType?.primaryKey !== gridDocTypePk) dispatch(clearLocationFiltersFromGridDataState());
  }, [activeDocType]);

  const doLogout = () => {
    dispatch(signOut());
    setShowTimeoutModal(false);
  };

  const doContinue = () => {
    clearTimeout(finalTimeout);
    Api.getAuthClient(dispatch).refreshAuthToken();
    warningLeadTimeMillis = timeToAuthExpiry * 1000 - (window as any).CSG_CONFIG.WARNING_LEADTIME_MILLIS;
    warningTimeout = setTimeout(sendTimeoutMessage, warningLeadTimeMillis);
    setShowTimeoutModal(false);
  };

  const sendTimeoutMessage = () => {
    setShowTimeoutModal(true);
    clearTimeout(finalTimeout);
    finalTimeout = setTimeout(doLogout, warningLeadTimeBackoff);
  };

  useEffect(() => {
    if (!isSignedIn || isLoggingOut) {
      clearTimeout(warningTimeout);
      clearTimeout(finalTimeout);
      return;
    }

    if (timeToAuthExpiry != 0 && isSignedIn && !isLoggingOut) {
      clearTimeout(warningTimeout);
      warningTimeout = setTimeout(sendTimeoutMessage, warningLeadTimeMillis);
    }

    if (isSignedIn && !isLoggingOut && !isNativeBC) {
      clearTimeout(warningTimeout);
      clearTimeout(finalTimeout);
    }
  }, [timeToAuthExpiry, isSignedIn, warningLeadTimeMillis]);

  const renderConditionalRoutes = () => {
    if (isSignedIn && !isPassResetRequired) {
      return (
        <>
          <Route path={MessageCenterRoute} element={<MessageCenter />} />
          <Route path={`${MessageDetailsRoute}/:messageId/:sysPrin/:docTypeId`} element={<MessageDetails />} />
          <Route path={MessageDetailsRoute} element={<MessageDetails />} />
          <Route path={TrashBinRoute} element={<TrashBin />} />
          <Route path={ReportingRoute} element={<Reporting />} />
          <Route path={UserAccountRoute} element={<UserAccount />} />
          <Route path={HelpDeskRoute} element={<ContactUs />} />
          <Route path={LandingRoute} element={<Landing />} />
          <Route path={TemplateMaintenanceRoute} element={<SelectivityTemplateMaintenance />} />
        </>
      );
    }

    return (
      <>
        <Route path={LoginRoute} element={<Login />} />
        <Route path={ForgotPasswordRoute} element={<ForgotPassword />} />
        <Route path={ForgotPasswordConfirmationRoute} element={<ForgotPasswordConfirmation />} />
        <Route path={HeartbeatRoute} element={<Heartbeat />} />
      </>
    );
  };

  const renderRoutes = () => {
    if (isFetchingWhoAmI) {
      return null;
    }

    return (
      <Routes>
        {renderConditionalRoutes()}
        <Route path={LoadingRoute} element={<SLoaderCenter sizePx={50} borderPx={4} />} />
        <Route path={HelpDeskRoute} element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  };

  return (
    <ThemeProvider theme={regularTheme}>
      <GlobalStyles />
      <ToastContainer containerId={bcToastContainerId} transition={Slide} theme="colored" />
      {isNetworkError ? (
        <NetworkError />
      ) : fullScreenErrorMsg ? (
        <CustomError error={fullScreenErrorMsg} />
      ) : (
        <Suspense fallback={<SLoaderCenter sizePx={50} borderPx={4} />}>
          {renderRoutes()}
        </Suspense> /* <Suspense fallback={<SLoaderCenter sizePx={50} borderPx={4} />}>{renderRoutes()}</Suspense> */
      )}
      {isNativeBC && <TimeoutModal showTimeoutModal={showTimeoutModal} doLogout={doLogout} doContinue={doContinue} />}
    </ThemeProvider>
  );
};

export default App;
